import React, { FC, useCallback } from 'react';

import { styled } from '../../theme';
import { Size } from '../../utility/common-props-helpers';
import SvgIcon from '../SvgIcon';
import { useAccordion } from './AccordionGroup';

const SummaryContent = styled('div')`
    width: 100%;
`;

const AccordionSummaryWrapper = styled('div')<{ isOpen: boolean; style?: React.CSSProperties }>(
    ({ theme, isOpen, style = {} }) => ({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: 10,
        borderBottom: theme.border.tableRowSeparator,
        minHeight: 70,
        transition: 'background-color 0.2s ease',

        ':hover': {
            background: theme.color.surface,
            svg: {
                color: theme.color.green1,
            },
        },
        ...style,
    })
);

const StyledIcon = styled(SvgIcon)<{ isOpen: boolean }>(({ theme, isOpen }) => ({
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.5s ease',
    justifySelf: 'flex-end',
}));

type Props = {
    style?: React.CSSProperties;
    id: string;
    arrowSize?: Size;
};

const StyledAccordionSummary: FC<Props> = ({ children, style, id, arrowSize = 'large' }) => {
    const { openedState, toggleOpenedState } = useAccordion();
    const isOpen = openedState.has(id);
    const handleClick = useCallback(() => {
        toggleOpenedState(id);
    }, [id, toggleOpenedState]);

    return (
        <AccordionSummaryWrapper isOpen={isOpen} onClick={handleClick} style={style}>
            <SummaryContent>{children}</SummaryContent>
            <StyledIcon src="/icons/ic-arrow-down.svg" size={arrowSize} isOpen={isOpen} />
        </AccordionSummaryWrapper>
    );
};

export default StyledAccordionSummary;
